export const set_current_quiz_invitation = (state, invitation) =>
  (state.current_invitation = invitation);
export const set_quiz_invitations = (state, invitations) =>
  (state.invitations = invitations);
